<breadcrumb endText="Announcement Config" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="flex justify-between">
    @if (!isEdit) {
      <div class="font-medium text-xl mb-2">
        {{dashboard}} Announcements
      </div>
    }
    @if (isEdit) {
      <div class="font-medium text-xl mb-2">
        Edit Announcement
      </div>
    }
    @if (!isEdit) {
      <div class="text-xs">
        <div class="rounded-[8px] border border-[#74808B] overflow-hidden">
          <button (click)="switchToInstructor('instructor')" [ngClass]="dashboard === 'instructor'? 'hover:bg-[#68737D] bg-[#74808B] border-r border-[#74808B] px-2 text-white' : 'hover:bg-gray-200 border-r border-[#74808B] px-2'">
            Instructor
          </button>
          <button (click)="switchToInstructor('universal')" [ngClass]="dashboard === 'universal'? 'hover:bg-[#68737D] bg-[#74808B] border-r border-[#74808B] px-2 text-white' : 'hover:bg-gray-200 border-r border-[#74808B] px-2'">
            Universal
          </button>
          <button (click)="switchToInstructor('student')" [ngClass]="dashboard === 'student'? 'hover:bg-[#68737D] bg-[#74808B] px-2 text-white' : 'hover:bg-gray-200 px-2'">
            Student
          </button>
        </div>
      </div>
    }
  </div>
  <!-- TODO add a switch to change between student and admin announcements -->
  <hr />
  <div class="grid grid-cols-3 mt-5 w-[80%]">
    Message:
    <textarea rows="5" [(ngModel)]="msg" type="text" class="col-span-2 input"></textarea>
  </div>
  <div class="flex justify-end mt-5">
    <outline-button (click)="cancelMessage()" text="Cancel" [marginRight]="true" />
    <full-button (click)="saveMessage()" text="Save" />
  </div>
</div>
